import React, { FunctionComponent, ReactElement, useEffect, useState } from "react";
import useClaimsToast from "../../hooks/useToast";
import logo from "../../assets/images/logo.png";
import { Button, Flex, FormControl, Heading, Input } from "@chakra-ui/react";
import { MainPageCard } from "../../shared/layout/index.styles";
import { postRequestPasswordReset } from "../../utils/api/auth";
import { RequestPasswordResetResponse } from "../../utils/api/protos/messages/auth.message_pb";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

interface ForgotPasswordProps {}

const ForgotPassword: FunctionComponent<ForgotPasswordProps> = (props: ForgotPasswordProps): ReactElement => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [userEmail, setUserEmail] = useState<string>("");

	const toast = useClaimsToast();
	const navigate = useNavigate();
	const { getUser } = useAuth();
	const user = getUser();

	const resetEmail = (): void => {
		setUserEmail("");
	};

	const handleInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
		if (event.key.toLowerCase() === "enter" && userEmail.length > 0) handleSubmit();
	};

	const handleSubmit = async (): Promise<void> => {
		setIsLoading(true);

		postRequestPasswordReset(userEmail)
			.then((response: RequestPasswordResetResponse) => {
				toast(
					"Success",
					"A password reset email was sent to the provided Email. Please check your Spam folder and allow a few minutes for the Email to arrive",
					"success"
				);
			})
			.catch((err) => {
				console.error(err);
				toast("Error", "There was a problem requesting a password reset for the given email", "error");
			})
			.finally(() => {
				resetEmail();
				setIsLoading(false);
			});
	};

	useEffect(() => {
		if (user) navigate(-1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	return (
		<Flex flexDirection="column" justifyContent="center" alignItems="center" p={7} w="100%">
			<img src={logo} alt="logo" />
			<MainPageCard mt={6}>
				<Heading mb="5" textAlign="center" color="secondary">
					Forgot Password
				</Heading>
				<Flex flexDirection="column" alignItems="center">
					<FormControl maxWidth={400}>
						<Input
							variant="mainInput"
							id="email"
							data-testid="forgot-password-email-input"
							type="email"
							placeholder="Email"
							value={userEmail}
							disabled={isLoading}
							onKeyDown={(e) => handleInputKeyDown(e)}
							onChange={(e) => setUserEmail(e.target.value)}
						/>
					</FormControl>
					<Button
						type="submit"
						data-testid="forgot-password-submit-btn"
						colorScheme="orange"
						minWidth={200}
						mt={5}
						isLoading={isLoading}
						onClick={() => handleSubmit()}>
						Submit
					</Button>
				</Flex>
			</MainPageCard>
		</Flex>
	);
};

export default ForgotPassword;
